<template>
  <div class="swipe-container">
    <van-swipe
      :show-indicators="false"
      class="my-swipe"
      :loop="false"
      :width="250"
      indicator-color="white"
    >
      <van-swipe-item
        v-for="(item, index) in list"
        :key="index"
        class="item"
      >
        <div class="item-contaienr"  @click="$emit('on-confrim',item)">
          <img
            :src="`${item.icon}?v=1.74`"
            class="icon"
          />
          <p class="name">{{item.equityName}}</p>
          <div class="price" v-if="item.price">￥{{item.memberPrice}} (<span class="line-through">￥{{item.price}}</span>)
          </div>
          <div class="price" v-else>{{item.equityDesc}}</div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'

export default {
  name: 'swiper',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem
  },
  data () {
    return {}
  },

  methods: {}
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.swipe-container {
  width: 670px;
  height: 250px;
  background: #fff;
  border-radius: 20px;

  .my-swipe {
    height: 100%;
    .van-swipe-item {
      height: 100%;
      display: flex;
      padding: 44px 20px;
      justify-content: space-around;
      .item-contaienr {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .icon {
        width: 80px;
        height: 80px;
        border-radius: 100%;
      }
      .name {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763E12;
        line-height: 37px;
        margin-top: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .price {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666;
      }
      .line-through {
        text-decoration: line-through;
      }
    }
  }
}
</style>